<template>
    <transition name="modal">
    <div>
    <div class="modal-mask" >
      <div class="modal-wrapper" @click="$emit('close')">
        <div class="modal-container" @click.stop="">
        <!-- <div class="modal fade" id="modalPaymentMethod" tabindex="-1" aria-labelledby="modalPaymentMethod" aria-hidden="true" ref="modal"> -->

            <div class="modal-dialog" role="document">
                <div class="modal-content" :class='{isTpg: isTpg, isJj: isJj}'  >
                    <div class="modal-title" style="margin-bottom: 10px;">
                        <span>Add Payment Method</span>
                        <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg, isJj: isJj}'>
                            <font-awesome-icon icon="times"  aria-hidden="false" />
                        </div>
                    </div>
                    <div class="solid-line" style="margin-bottom: 20px;"></div>
                    <form method="post" enctype="multipart/form-data" @submit.prevent="submitForm" class="form-check" :class="{isTpg:isTpg, isJj: isJj}" name="zone_form"  style="margin-bottom: 0px;height:auto;min-height:auto;">
                        <div class="onboarding-container"   style="margin-bottom: 30px;height:auto;min-height:auto;">

                            <div style="margin-bottom:15px;padding-left:8px;">
                                <div class="player-update-radios">
                                    <div class="form-check">
                                        <label class="form-check-label">
                                            <input data-creditcardoption
                                                    class="form-check-input"
                                                   type="radio"
                                                   name="cc_or_ach"
                                                   v-model="cc_or_ach"
                                                   value="creditcard">
                                            &nbsp;&nbsp;Credit Card
                                        </label>
                                    </div>
                                    <div class="form-check" style="margin-top:10px;">
                                        <label class="form-check-label">
                                            <input data-achoption
                                                   class="form-check-input"
                                                   type="radio"
                                                   name="cc_or_ach"
                                                   v-model="cc_or_ach" value="ACH">
                                            &nbsp;&nbsp;ACH
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div v-if="cc_or_ach === 'creditcard'" class="ccOrAch">
                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3">
                                      Name (<span :class="{inlineError:v$.card_first_name.$error,isTpg:isTpg, isJj: isJj}">First</span>,<span :class="{inlineError:v$.card_last_name.$error,isTpg:isTpg, isJj: isJj}">Last</span>):
                                    </div>
                                    <div class="col-lg-9">
                                        <div class="">
                                            <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                                <input name="Card First Name"
                                                       type="text"
                                                       v-model="card_first_name"
                                                       data-cardfirstname>
                                            </div>
                                            <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                                <input type="text"
                                                       name="Card Last Name"
                                                       v-model="card_last_name"
                                                       data-cardlastname>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3 workspace_content_form_row_title" >
                                        <span :class="{inlineError:v$.card_type.$error,isTpg, isJj: isJj}">Card Type </span>
                                    </div>
                                    <div class="col-lg-9 workspace_content_form_row_input">
                                       <vue-select close-on-select
                                                data-cardtype
                                                class="thirty"
                                                  v-model="card_type"
                                                  autocomplete="false"
                                                  name="Card Type"
                                                  :options="[{'id':'Visa','name':'Visa'},{'id':'MasterCard','name':'Master Card'},{'id':'AmEx','name':'American Express'},{'id':'Discover','name':'Discover'}]"
                                                  label-by="name"></vue-select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-3">
                                        <span :class="{inlineError:v$.card_number.$error,isTpg:isTpg, isJj: isJj}">Card #</span>
                                    </div>
                                    <div class="col-lg-9">
                                        <input data-cardnumber
                                               type="text"
                                               v-model="card_number"
                                               name="Card Number"
                                               id="card_number">
                                    </div>
                                </div>

                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3 workspace_content_form_row_title">
                                        <span :class="{inlineError:v$.expire_month.$error,isTpg:isTpg, isJj: isJj}">Exp Month</span>,  <span :class="{inlineError:v$.expire_year.$error,isTpg:isTpg, isJj: isJj}">Year:</span>
                                    </div>
                                       <div class="col-lg-9 workspace_content_form_row_input">
                                        <div class="">
                                            <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                                <vue-select
                                                        class="thirty"
                                                        close-on-select
                                                        data-cardexpmonth
                                                          v-model="expire_month" autocomplete="false"
                                                          name="Expiration Month"
                                                          :options="filteredMonths"
                                                          label-by="name"></vue-select>
                                            </div>
                                            <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                                <vue-select close-on-select
                                                        data-cardexpyear
                                                        class="thirty"
                                                        v-model="expire_year"
                                                          autocomplete="false"
                                                          name="Expiration Year"
                                                          :options="expYears"
                                                          label-by="name"></vue-select>
                                            </div>
                                        </div>
                                       </div>
                                </div>

                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3" :class="{inlineError:v$.card_cvv.$error,isTpg:isTpg, isJj: isJj}">
                                        CVV
                                    </div>
                                    <div class="col-lg-9">
                                        <input data-cardcvv
                                               type="text"
                                               id="card_cvv"
                                               name="Card CVV"
                                               v-model="card_cvv">
                                    </div>
                                </div>
                            </div>

                            <div v-if="cc_or_ach === 'ACH'">
                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3">
                                        Name (<span :class="{inlineError:v$.ach_first_name.$error,isTpg:isTpg, isJj: isJj}">First</span>,<span :class="{inlineError:v$.ach_last_name.$error,isTpg:isTpg, isJj: isJj}">Last</span>):
                                    </div>
                                    <div class="col-lg-9">
                                        <div class="">
                                            <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                                <input name="ACH First Name"
                                                       type="text"
                                                       v-model="ach_first_name"
                                                       data-achfirstname>
                                            </div>
                                            <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                                <input type="text"
                                                       name="ACH Last Name"
                                                       v-model="ach_last_name"
                                                       data-achlastname>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group workspace-content-form-row row" >
                                    <div class="col-lg-3" :class="{inlineError:v$.routing_number.$error,isTpg:isTpg, isJj: isJj}">Routing Number:</div>
                                    <div class="col-lg-9">
                                        <input data-achroutingnumber
                                               type="text"
                                               name="Routing Number"
                                               v-model="routing_number"
                                               id="routing_number">
                                    </div>
                                </div>
                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3" :class="{inlineError:v$.account_number.$error,isTpg:isTpg, isJj: isJj}">Account Number:</div>
                                    <div class="col-lg-9">
                                        <input data-achaccountnumber
                                               type="text"
                                               name="Account Number"
                                               id="account_number"
                                               v-model="account_number">

                                    </div>
                                </div>
                                <div class="form-group workspace-content-form-row row">
                                    <div class="col-lg-3" :class="{inlineError:v$.account_type.$error,isTpg:isTpg, isJj: isJj}">Account Type:</div>
                                    <div class="col-lg-9">
                                        <vue-select close-on-select data-achaccounttype
                                                  v-model="account_type"
                                                class="thirty"
                                                  autocomplete="false"
                                                  name="Billing Account Type"
                                                  :options="[{'id':'c','name':'Checking'},{'id':'s','name':'Savings'}]"
                                                  label-by="name"></vue-select>
                                    </div>
                                </div>
                            </div>

                            <div style="width:100%;text-align: center;margin-top:40px;margin-bottom:0px">
                                <button class="clean-grayv" type="submit" style="width:300px;margin-bottom:0px" :disabled="formHasBeenSubmitted">Submit</button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        <!-- </div> -->
    </div>
      </div></div></div>
    </transition>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { requiredIf, helpers } from '@vuelidate/validators';

const Querystring = require('querystring');
// import forte from 'forte'
// import forte from '../../assets/forte/index.js';
// const forte = require('../../assets/forte/index.js');

export default {
  props: ['is-tpg', 'user-info', 'location-id', 'is-jj'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      API_LOGIN_ID_SAND: 'CKe8y7YuH',
      API_LOGIN_ID_GV: '68MkW13cIa',
      API_LOGIN_ID_TPG: 'yAV0Fc00p7',
      errorString: '',
      cc_or_ach: 'creditcard',
      card_first_name: '',
      card_last_name: '',
      card_number: '',
      card_type: null,
      expire_year: null,
      expire_month: null,
      card_cvv: '',
      account_number: '',
      routing_number: '',
      account_type: null,
      ach_first_name: '',
      ach_last_name: '',
      one_time_token: '',
      formHasBeenSubmitted: false,
    };
  },
  validations() {
    return {
      card_first_name: {
        required: helpers.withMessage('Card first name is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_last_name: {
        required: helpers.withMessage('Card last name is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_type: {
        required: helpers.withMessage('Card type is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_number: {
        required: helpers.withMessage('Card number is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      expire_month: {
        required: helpers.withMessage('Expiration month is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      expire_year: {
        required: helpers.withMessage('Expiration year is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      card_cvv: {
        required: helpers.withMessage('Card cvv is required', requiredIf(function () {
          return this.cc_or_ach == 'creditcard';
        })),
      },
      ach_first_name: {
        required: helpers.withMessage('ACH first name is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      ach_last_name: {
        required: helpers.withMessage('ACH last name is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      routing_number: {
        required: helpers.withMessage('Routing number is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      account_number: {
        required: helpers.withMessage('Account number is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
      account_type: {
        required: helpers.withMessage('Account type is required', requiredIf(function () {
          return this.cc_or_ach == 'ACH';
        })),
      },
    };
  },
  mounted() {
  },
  methods: {
    show() {
      this.clearModel();
      // $("#modalPaymentMethod").modal({
      //     backdrop: 'static',
      //     keyboard: true
      // });
      // $('.modal-backdrop').css("opacity",".8");

      if (!this.locationId) {
        this.errorString = 'Error: No location id set';
        this.$wkToast(this.errorString);
      } else {
        this.errorString = '';
      }
    },
    // cancel: function () {
    //     this.clearModel();
    //     $('#modalPaymentMethod').modal('hide');
    // },
    submitForm() {
      this.formHasBeenSubmitted = false;
      this.v$.$validate();
      this.errorString = '';
      if (!this.v$.$error) {
        this.getForteToken();
      } else {
        this.formHasBeenSubmitted = false;
        const errors = this.v$.$errors;
        let errorList = '<b>Errors</b></b><ul>';
        for (let i = 0; i < errors.length; i++) {
          errorList += `<li>${errors[i].$message}</li>`;
        }

        errorList += '</ul>';
        const validationErrorList = errorList;
        this.$wkToast(validationErrorList);
      }

      // this.$validator.validateAll().then(res=>{
      //     if(res) {
      //         this.getForteToken();
      //     } else {
      //         this.formHasBeenSubmitted = false;
      //         var errorBag = this.errors.all();
      //         this.errorString = this.listizeErrors(errorBag);
      //         //console.log(JSON.stringify(errorBag));
      //         //console.log(JSON.stringify((this.errors)));
      //         //this.errorString = 'Please fix the following error(s): ' + this.errorString;
      //         this.$toast.show(this.errorString);
      //     }
      // })
    },
    getForteToken() { //
      let forte_token = this.API_LOGIN_ID_GV;
      if (this.isTpg) {
        forte_token = this.API_LOGIN_ID_TPG;
      }

      // forte_token = this.API_LOGIN_ID_SAND;

      const paymentMethod = { api_login_id: forte_token };

      // If has any payment info.. then validate
      // if (this.hasCompletePaymentInfo() || this.hasCompletePaymentInfo() === true) {
      if (this.cc_or_ach === 'creditcard') {
        paymentMethod.card_number = this.card_number;
        paymentMethod.expire_year = this.expire_year.id;
        paymentMethod.expire_month = this.expire_month.id;
        paymentMethod.cvv = this.card_cvv;
      } else {
        paymentMethod.account_number = this.account_number;
        paymentMethod.routing_number = this.routing_number;
        paymentMethod.account_type = this.account_type.id;
      }

      forte.createToken(paymentMethod)
        .success(this.forteTokenCreated)
        .error(this.forteTokenError);

      return false;
    },
    forteTokenCreated(response) {
      this.one_time_token = response.onetime_token;
      const event_data = {
        web_tracking_event_type_id: 11,
        page_name: 'PaymentMethod',
        location_id: this.locationId,
        message: `Forte Token Created: ${response.onetime_token}`,
      };
      this.logForteEvent(event_data);
      // console.log("got the token " + response.onetime_token);

      // If this location is a JimmyJohns, do not issue request to POST /payment
      if (this.locationId == 'JIMMYJOHNS') {
        const data = {
          one_time_token: this.one_time_token,
        };
        if (this.cc_or_ach === 'creditcard') {
          data.type = 'card';
          data.name = `${this.card_first_name} ${this.card_last_name}`;
        } else {
          data.type = 'ach';
          data.name = `${this.ach_first_name} ${this.ach_last_name}`;
        }
        this.$emit('jjPaymentMethodCreated', data);
        this.$emit('close');
        // $('#modalPaymentMethod').modal('hide');
        return;
      }
      this.createPaymentMethod();
    },
    forteTokenError(response) {
      this.formHasBeenSubmitted = false;
      const event_data = {
        web_tracking_event_type_id: 11,
        page_name: 'PaymentMethod',
        location_id: this.locationId,
        message: `Forte Token Error: ${response.response_description}`,
      };
      this.logForteEvent(event_data);
      alert(`There was a problem saving your payment information: ${response.response_description}`);
    },
    logForteEvent(event_data) {
      this.$http.post('/event', Querystring.stringify(event_data)).then(() => {

      });
    },
    paymentTypeLabel() {
      let label = '';
      if (this.cc_or_ach === 'creditcard') {
        label = `CC xx${this.card_number.substr(this.card_number.length - 3)}`;
      } else {
        label = `ACH xx${this.account_number.substr(this.account_number.length - 3)}`;
      }
      return label;
    },
    createPaymentMethod() {
      const paymentMethod = {
        one_time_token: this.one_time_token,
        'location[id]': this.locationId,
      };
      if (this.cc_or_ach === 'creditcard') {
        paymentMethod.type = 'card';
        // paymentMethod.card_number = this.card_number;
        // paymentMethod.expire_year = this.expire_year.id;
        // paymentMethod.expire_month = this.expire_month.id;
        // paymentMethod.cvv = this.card_cvv;
        paymentMethod.name = `${this.card_first_name} ${this.card_last_name}`;
      } else {
        paymentMethod.type = 'ach';
        // paymentMethod.account_number = this.account_number;
        // paymentMethod.account_number = this.routing_number;
        // paymentMethod.account_type = this.account_type.id;
        paymentMethod.name = `${this.ach_first_name} ${this.ach_last_name}`;
      }

      const self = this;
      this.$http.post('/payment', Querystring.stringify(paymentMethod)).then((response) => {
        self.formHasBeenSubmitted = false;

        if (response.data.success == true) {
          paymentMethod.label = self.paymentTypeLabel();
          self.$emit('newPaymentMethodCreated', paymentMethod);
          self.$emit('close');
        } else if (response.data.code == 200) {
          paymentMethod.label = self.paymentTypeLabel();
          self.$emit('newPaymentMethodCreated', paymentMethod);
          self.$emit('close');
        } else if (response.data.error === true) {
          if (response.data.message) {
            self.errorString = response.data.message;
            self.$wkToast(self.errorString);
          } else if (response.data.data.fields) {
            self.errorString = self.returnFriendlyErrors(response.data.data.fields);
            self.$wkToast(self.errorString);
          } else {
            self.errorString = 'An error occurred.';
            self.$wkToast(self.errorString);
          }
        }
      },
      (response) => {
        self.formHasBeenSubmitted = false;
        if (response.data && response.data.data && response.data.data.api_response && response.data.data.api_response.response && response.data.data.api_response.response.response_desc) {
          self.errorString = `ERROR: ${response.body.data.api_response.response.response_desc}`;
          self.$wkToast(self.errorString);
        } else if (response.data && response.data.message) {
          self.errorString = `Error: ${response.data.message}`;
          self.$wkToast(self.errorString);
        } else {
          self.errorString = 'Error creating payment. Check your entry and try again.';
          self.$wkToast(self.errorString);
        }
      });
    },
    clearModel() {
      this.errorString = '';
      this.cc_or_ach = 'creditcard';
      this.card_number = '';
      this.expire_year = null;
      this.expire_month = null;
      this.card_type = null;
      this.card_cvv = '';
      this.account_number = '';
      this.routing_number = '';
      this.account_type = null;
      this.one_time_token = '';
      this.card_first_name = '';
      this.card_last_name = '';
      this.ach_first_name = '';
      this.ach_last_name = '';
      this.formHasBeenSubmitted = false;
    },
    returnFriendlyErrors(errors) {
      let friendlyErrors = '';
      for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
          if (friendlyErrors) {
            friendlyErrors = `${friendlyErrors}<br>- ${errors[key]}`;
          } else {
            friendlyErrors = `- ${errors[key]}`;
          }
        }
      }

      return friendlyErrors;
    },
    listizeErrors(e) {
      let list = "<ul style='text-align: left;margin-top:5px'>";
      for (let i = 0; i < e.length; i++) {
        list = `${list}<li>${e[i]}</li>`;
      }

      list = `${list}</ul>`;
      return list;
    },
  },
  components: {

  },
  computed: {
    filteredMonths() {
      const allMonths = [
        { i: 1, id: '01', name: 'January' },
        { i: 2, id: '02', name: 'February' },
        { i: 3, id: '03', name: 'March' },
        { i: 4, id: '04', name: 'April' },
        { i: 5, id: '05', name: 'May' },
        { i: 6, id: '06', name: 'June' },
        { i: 7, id: '07', name: 'July' },
        { i: 8, id: '08', name: 'August' },
        { i: 9, id: '09', name: 'September' },
        { i: 10, id: '10', name: 'October' },
        { i: 11, id: '11', name: 'November' },
        { i: 12, id: '12', name: 'December' }];

      return allMonths;
    },
    expYears() {
      const expYears = [];
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i < currentYear + 10; i++) {
        const y = { id: `${i}`, name: `${i}` };
        expYears.push(y);
      }
      return expYears;
    },
  },
  watch: {
    // showModal: {
    // handler(newVal) {
    //     this.active = newVal;
    //     const body = document.querySelector("body");
    //     this.showModal ? body.classList.add("modal-open") : body.classList.remove("modal-open")
    // },
    // immediate: true,
    // deep: true,
    // },
  },
};
</script>

<style scoped>
input[type="radio"] {
    background:white;
    border:1px solid black
}
input[type='radio']:checked:before {
    border:1px solid #ccc
}
    .modal-dialog {
        padding:0px;
        /* width:auto;
        max-width:700px;
        margin:0 auto;
        margin-top:50px;
        padding:0px; */
    }
    .modal-content {
        background: #666;
        color:white;
        /* width:auto;
        max-width:700px;
        /* margin:0 auto;

        padding:0px; */
    }
    .onboarding-container {
        text-align: left;
    }
    .onboarding-container input[type="text"] {
        border:0px solid #ccc;
        background:#fff;
        color:#000;
        border-radius: 5px;
        width:100%;
        height:36px;
        font-weight: normal;
    }

    .modal-content.isJj input[type="text"] {
      border:1px solid #ccc;
    }
.close-modal {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
  text-align: right;
  width:20px;
  height:20px;
}
    .close-modal.isTpg {
        color:black;
    }
    .close-modal.isJj {
        color:black;
        top:3px;
    }
    .modal-content.isTpg {
        background: #ccc;
        color:black;
    }
    .modal-content.isJj {
        background: #fff;
        color:black;
        border:0px solid orangered
    }
    .inlineError.isJj {
        color:rgb(224,0,43);
    }
</style>
